<template>
    <div class="signup_form" full-height>
        <v-toolbar flat fixed>
            <!-- <v-toolbar-title>{{$route.query.usertype==1 ? 'Register Business' : 'Register as Accountant'}}</v-toolbar-title> -->
            <v-toolbar-title>{{ $t('signup.toolbarTitle') }}</v-toolbar-title>
            <!-- <v-spacer></v-spacer>
            <v-menu>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <img src="../../assets/icon_help.svg" style="width:20px"/>
                    </v-btn>
                </template>
                <v-list dense nopadding>
                    <v-list-item @click="$root.fn_whatsAppSupport">
                        <v-list-item-action class="mr-2"><img src="../../assets/icon_whatsapp.svg" style="width:20px"/></v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Contact Support</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu> -->
            <!-- <v-spacer></v-spacer>
            <v-btn text icon @click="fn_checkValidations">Save</v-btn> -->
           <!--  <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                    <img src="../../assets/more-icon.svg" style="margin-top:5px; width:28px"/>
                </v-btn>
              </template>
              <v-list nopadding>
                <v-list-item @click="fn_openDialogACtivateBusiness">
                  <v-list-item-title>Activate Old Business</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu> -->
            <!-- <v-btn color="success" @click="fn_getStates">text</v-btn> -->
        </v-toolbar>

        <div class="hastoolbar hasBigfooter">
            <!-- <v-alert icon="info_outline" style="background-color: rgba(66, 165, 245, 0.15);font-size: 14px;" class="mb-0 pt-3 pb-3" :value="true">
                Lifetime <strong>FREE</strong> for single business use
            </v-alert> -->
            <!-- <v-alert style="background-color: rgba(66, 165, 245, 0.15);font-size: 14px;" class="mb-0 pt-3 pb-3" :value="true">
                <span class="mr-4" style="border: 1px solid;border-radius: 50%;padding: 1px 8px;color: rgba(0, 0, 0, 0.54);font-size: 16px;">&#8505;</span> Lifetime <strong>FREE</strong> for single business use
            </v-alert> -->
            <div style="background-color: rgba(66, 165, 245, 0.15);font-size: 14px;" class="pt-3 pb-3 pl-4 -r-4">
                <img class="mr-4" src="../../assets/icon_info.svg" alt="_" style="float: left;">
                <div style="padding-top: 2px;" v-html="$t('signup.lifetimeFreeBanner')"></div>
            </div>
            <!-- <div id="push_alert" style="padding: 8px 16px;display: flex;background-color: rgba(66, 165, 245, 0.15);">
                <span style="font-size: 14px;">Add "Business Name" and "State" and you're done.</span>
                <v-spacer></v-spacer>
                <v-btn @click="fn_removeAlert" style="height: 24px;width: 24px;" small flat icon><span style="font-size: 16px;color: rgba(0,0,0,0.87);">&#10005;</span></v-btn>
            </div> -->
            <!-- <v-form class="form-element grey-back" v-if="$route.query.usertype==1"> -->
            <v-form class="form-element grey-back">

                <v-layout align-center nomargin padding-top-ten row wrap white-background>
                    <v-flex xs12 sm12 md12 form-item padding-top-ten>
                       <v-text-field
                            v-model="Form.BusinessName"
                            :label="$t('signup.businessName')"
                            placeholder=" "
                            v-validate="'required'"
                            data-vv-name="businessName" 
                            data-vv-as="business name" 
                            :error-messages="errors.collect('businessName')"
                            required>
                                
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12 padding-top-ten form-item @click="fn_openStateDialog('android', 'state', 'ref_fieldState')">
                        <v-text-field
                            readonly
                            :onUpdate="fn_updateState"
                            ref="ref_fieldState"
                            v-model="Form.State"
                            :label="$t('signup.state')"
                            placeholder=" "
                            append-icon="mdi-menu-down"
                            v-validate="'required'"
                            data-vv-name="state"
                            data-vv-as="state"
                            :error-messages="errors.collect('state')"
                            required>
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12 padding-top-ten>
                        <!-- <v-list style="margin: 16px;border: 0.5px solid #ddd;border-radius: 5px !important;"> -->
                        <v-list>
                            <div class="pl-4" style="color: rgba(0,0,0,0.54);font-size: 12px;">{{ $t('signup.gstRegistrationStatus') }}</div>
                            <v-list-item :class="{'selected-list-radio':item.status == Form.GSTRegistrationStatus}" style="background: #f0f0f0;margin: 16px;border-radius: 5px;" v-for="(item, index) in registrationTypes" :key="index" @click="fn_updateRegistrationType(item)">
                            <!-- <v-list-item v-for="(item, index) in registrationTypes" :key="index" @click="fn_updateRegistrationType(item)"> -->
                                <v-list-item-action class="mr-6">
                                    <div style="width: 20px;height: 20px;background: #fff;line-height: 1;padding: 2px 3px;border-radius: 50%;color: #42A5F5;" v-if="item.status == Form.GSTRegistrationStatus">&#10004;</div>
                                    <!-- <v-icon color="primary" v-if="item.status == Form.GSTRegistrationStatus">check_circle</v-icon> -->
                                    <!-- <v-icon v-else>mdi-radiobox-blank</v-icon> -->
                                    <div style="width: 20px;height: 20px;border-radius: 50%;border: 1px rgba(0,0,0,0.54) solid;" v-else></div>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>{{ fn_regTypeName(item.status) }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>

                        </v-list>
                    </v-flex>

                    <!-- <v-flex xs12 sm12 md12 form-item padding-top-ten>
                       <v-text-field  
                            v-model="Form.UserName" 
                            label="Business Owner Name" 
                            placeholder=" "
                            v-validate="'required'"
                            data-vv-name="username" 
                            data-vv-as="business owner name" 
                            :error-messages="errors.collect('username')"
                            required>
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12 form-item padding-top-ten>
                        <v-textarea
                            v-model="Form.Address"
                            label="Address (will appear on invoice and bill prints)"
                            placeholder=" "
                            rows="2"
                            counter="250"
                            v-validate="'max:250'"
                            data-vv-name="address" 
                            data-vv-as="address" 
                            :error-messages="errors.collect('address')"
                            required>
                        </v-textarea>
                    </v-flex> -->

                    <!-- <v-flex xs12 sm12 md12 padding-top-ten form-item @click="fn_openDatepicker">
                        <v-text-field
                            readonly
                            label="Opening Date" 
                            placeholder=" " 
                            :value="fn_getOpeningDate()">
                        </v-text-field>
                    </v-flex> -->

                    <!-- <v-flex xs12 sm12 md12 form-item padding-top-ten>
                        <div class="mb-1" style="color: rgba(0,0,0,0.54);font-size: 12px;">Are you an Accountant?</div>

                        <v-radio-group class="mt-2" v-model="Form.UserType" row>
                            <v-radio class="check_box_block" label="No" :value="1"></v-radio>
                            <v-radio class="check_box_block" label="Yes" :value="2"></v-radio>
                        </v-radio-group>

                    </v-flex> -->
                </v-layout>

                <!-- <v-layout nomargin row wrap padding-top-ten white-background>

                    <v-flex xs12 sm12 md12 form-item @click="fn_openRegistrationTypes">
                       <v-text-field  
                            readonly
                            :value="registrationType"
                            label="GST Registration Status"
                            placeholder=" " 
                            append-icon="mdi-menu-down"
                            v-validate="'required'" 
                            data-vv-name="regType"
                            data-vv-as="GST registration status"
                            :error-messages="errors.collect('regType')"
                            required>
                       </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12 form-item padding-top-ten v-if="Form.GSTRegistrationStatus == 1 || Form.GSTRegistrationStatus == 2">
                       <v-text-field
                            @input="fn_toUpperCase"
                            label="GST Number (GSTIN)" 
                            :hide-details="!errors.has('gstNumber')"
                            placeholder=" " 
                            v-model="Form.GSTNumber" 
                            v-validate="'required|verify_gstnumber'"
                            name="GSTNumber" 
                            data-vv-name="gstNumber" 
                            data-vv-as="GST number" 
                            :error-messages="errors.collect('gstNumber')" 
                            required>
                        </v-text-field>
                        <div class="pt-1" right-align font12 light-opacity-color>Example: 12ABCDE1234A9Z9</div>
                    </v-flex>

                </v-layout> -->

                <!-- <v-layout pb-3 nomargin row wrap padding-top-ten white-background>
                    <v-flex xs12 sm12 md12 form-item @click="fn_openDatepicker">
                        <v-text-field
                            readonly
                            label="Opening Date" 
                            placeholder=" " 
                            :value="fn_getOpeningDate()">
                        </v-text-field>
                    </v-flex>
                </v-layout> -->

            </v-form>

            <!-- <v-form class="form-element" v-else-if="$route.query.usertype==1">
                <template>
                    <v-stepper v-model="e1">

                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-card flat class="mb-5">
                                    <v-layout align-center nomargin padding-top-ten row wrap white-background>
                                        <v-flex xs12 sm12 md12 form-item padding-top-ten>
                                            <v-text-field  
                                                v-model="Form.BusinessName" 
                                                label="Business Name" 
                                                placeholder=" "
                                                v-validate="'required'"
                                                data-vv-name="businessName" 
                                                data-vv-as="business name" 
                                                :error-messages="errors.collect('businessName')"
                                                required>
                                                    
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>

                                    <v-list style="margin: 16px;border: 0.5px solid #ddd;border-radius: 5px !important;">
                                        <div class="pl-4 pr-4 pt-2" style="color: rgba(0,0,0,0.54);">GST Registration Status</div>
                                        <v-list-item style="background: #eee;margin: 16px;border-radius: 5px;" v-for="(item, index) in registrationTypes" :key="index" @click="fn_updateRegistrationType(item)">
                                            <v-list-item-content>
                                                <v-list-item-title>{{item.name}}</v-list-item-title>
                                            </v-list-item-content>

                                            <v-list-item-action>
                                                <v-icon color="primary" v-if="item.status == Form.GSTRegistrationStatus">mdi-radiobox-marked</v-icon>
                                                <v-icon v-else>mdi-radiobox-blank</v-icon>
                                            </v-list-item-action>
                                        </v-list-item>

                                    </v-list>
                                </v-card>
                            </v-stepper-content>

                            <v-stepper-content step="2">
                                <v-card flat class="mb-5" v-if="e1==2">
                                    <v-layout align-center nomargin padding-top-ten row wrap white-background>
                                        <v-flex xs12 sm12 md12 padding-top-ten form-item v-if="Form.GSTRegistrationStatus == 1 || Form.GSTRegistrationStatus == 2">
                                            <v-text-field
                                                :disabled="gstNumberOption"
                                                @input="fn_onGstNumberEdit"
                                                :label="Form.State && !errors.has('gstNumber') && !gstNumberOption ? 'GST Number (GSTIN) - ' + Form.State : 'GST Number (GSTIN)'" 
                                                :hide-details="!errors.has('gstNumber')"
                                                placeholder=" " 
                                                v-model="Form.GSTNumber" 
                                                v-validate="!gstNumberOption ? 'required|verify_gstnumber' : ''"
                                                name="GSTNumber" 
                                                data-vv-name="gstNumber" 
                                                data-vv-as="GST number" 
                                                :error-messages="errors.collect('gstNumber')" 
                                                required>
                                            </v-text-field>
                                            <div class="pt-1" right-align font12 light-opacity-color>Example: 12ABCDE1234A9Z9</div>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 padding-top-ten v-if="Form.GSTRegistrationStatus === 3 || gstNumberOption" form-item @click="fn_openStateDialog('android', 'state', 'ref_fieldState')">
                                            <v-text-field  
                                                readonly
                                                :onUpdate="fn_updateState"
                                                ref="ref_fieldState"
                                                v-model="Form.State" 
                                                label="State" 
                                                placeholder=" " 
                                                append-icon="mdi-menu-down"
                                                v-validate="'required'"
                                                data-vv-name="state" 
                                                data-vv-as="state" 
                                                :error-messages="errors.collect('state')"
                                                required>
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 padding-top-ten form-item @click="fn_openDatepicker">
                                            <v-text-field
                                                readonly
                                                label="Opening Date" 
                                                placeholder=" " 
                                                :value="fn_getOpeningDate()">
                                            </v-text-field>
                                        </v-flex>

                                        <v-checkbox class="gst_check_box form-item" label="Add GST Number Later" v-model="gstNumberOption" @change="fn_gstNumberOption"></v-checkbox>
                                    </v-layout>
                                </v-card>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                    </template>
            </v-form> -->

            <!-- <v-form class="form-element grey-back" v-else>
                <v-layout align-center nomargin padding-top-ten row wrap white-background>

                    <v-flex xs12 sm12 md12 form-item>
                       <v-text-field  
                            v-model="Form.UserName" 
                            label="Your Name" 
                            placeholder=" "
                            v-validate="'required'"
                            data-vv-name="username" 
                            data-vv-as="name" 
                            :error-messages="errors.collect('username')"
                            required>
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12 form-item @click="fn_openStateDialog('android', 'state', 'ref_fieldState')">
                        <v-text-field  
                            readonly
                            :onUpdate="fn_updateState"
                            ref="ref_fieldState"
                            v-model="Form.State" 
                            label="State" 
                            placeholder=" " 
                            append-icon="mdi-menu-down"
                            v-validate="'required'"
                            data-vv-name="state" 
                            data-vv-as="state" 
                            :error-messages="errors.collect('state')"
                            required>
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </v-form> -->

            <!-- <v-footer style="position:fixed;bottom:0;width:100%;padding:0">
                <v-btn block color="primary" style="height:48px;border-radius:0" @click="fn_checkValidations">Save</v-btn>
            </v-footer> -->
            <v-footer style="background-color: #fff;position:fixed;bottom:0;width:100%;padding:16px;">
                <v-btn block color="primary" style="height:52px;border-radius:8px" :key="saveBtnKey" @click.once="fn_checkValidations">{{ $t('signup.getStartedBtn') }}</v-btn>

                <v-layout row wrap>
                    <v-flex xs12 sm12 md12 center-align @click="$root.fn_whatsAppSupport">
                        <div class="pa-4 pb-0" font14 style="letter-spacing: 0.5px;font-weight: 500;"><span style="color: #4b77be;"><img src="../../assets/icon_support.svg" style="width:20px;margin-bottom: -4px;"/> {{ $t('common.contactSupport') }}</span></div>
                    </v-flex>
                </v-layout>
            </v-footer>
        </div>  

        <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="actionMethod"></dialog-confirmation>

        <dialog-registration-types ref="ref_dialogRegistrationTypes" :registrationTypes="registrationTypes" :selectedRegistrationType="Form.GSTRegistrationStatus"></dialog-registration-types>

        <dialog-activate-business ref="ref_dialogActivateBusiness" :businesses="businesses" :openDialogConfirmation="fn_openDialogConfirmation"></dialog-activate-business>

        <dialog-date-picker ref="ref_dialogDatePicker" :selected="Form.OpeningDate" :minimumDate="minDate" :maximumDate="maxDate" :updateDate="fn_updateDate"></dialog-date-picker>

        <!-- <v-snackbar :timeout="0" v-model="msgAlert">Something went wrong!
            <v-btn text color="primary" @click.native="fn_checkValidations">retry</v-btn>
        </v-snackbar> -->
    </div>
</template>

<script>
const dialogjs =  require('../../dialog').dialogjs;
import dialogRegistrationTypes from './dialogs/dialog_registration_types'
import dialogConfirmation from '../dialogs/dialog_confirmation'
import dialogActivateBusiness from './dialogs/dialog_activate_business'
import dialogDatepicker from './dialogs/dialog_datepicker'

    export default{
        data(){
            return{
                // Form:{"BusinessName":null, "UserName":null, "StateID":null, "State":null, "GSTRegistrationStatus":null, "GSTNumber":null, "GSTRegistrationDate":null, "HSNApplicable":false, "DeviceID":null, "TaxMode":null, "OpeningDate":null, "IsAccountantOnly":false},
                Form:{"BusinessName":null, "UserName":null, "StateID":null, "State":null, "GSTRegistrationStatus":1, "GSTNumber":null, "GSTRegistrationDate":null, "HSNApplicable":true, "DeviceID":null, "TaxMode":1, "OpeningDate":null, "IsAccountantOnly":false, "RegistrationOnBehalf":false, "BusinessOwnerNumber":null, "UserType":1},
                formId:null,
                dialogStorageId:null,
                showFooter:true,
                loading:null,
                confirmationHeader:null,
                confirmationMessage:null,
                actionMethod:null,
                confirmExit:false,
                // registrationTypes:[{"status":1, "name":"Registered"},{"status":2, "name":"Composite"},{"status":3, "name":"Not Registered"}],
                registrationTypes:[{"status":1, "name":"Registered - Regular"},{"status":2, "name":"Registered - Composite"},{"status":3, "name":"Unregistered"}],
                // msgAlert:false,
                businesses:null,
                itemToActivate:null,
                minDate:"2022-04-01",
                // maxDate:"2024-03-31",
                maxDate:"2027-03-31",
                // isAccountant:false,
                saveBtnKey:1,
                // ownerType:1
                // pushAlert:false
                // e1:1,
                // gstNumberOption:false,
                // states:null
            }
        },
        components:{
            'dialog-confirmation': dialogConfirmation,
            'dialog-registration-types': dialogRegistrationTypes,
            'dialog-activate-business': dialogActivateBusiness,
            'dialog-date-picker': dialogDatepicker,
        },
        methods: {

            // fn_test: function(){
            //     this.confirmExit = true;
            //     let self = this;
            //     setTimeout(function(){
            //         self.$router.push({path:'/registration/business/restore_data', query:{exitapp:1}});
            //     },300);
            // },

            // fn_gstNumberOption: function(){
            //     this.Form.GSTNumber = null;
            // },

            fn_removeAlert: function(){
                document.getElementById("push_alert").remove();
            },

            fn_regTypeName: function(status){
                if(status == 1) return this.$t('signup.regTypeRegistered');
                if(status == 2) return this.$t('signup.regTypeComposite');
                if(status == 3) return this.$t('signup.regTypeUnregistered');
                return '';
            },

            fn_updateRegistrationType: function(item){
                this.Form.GSTRegistrationStatus = item.status;
                // this.errors.remove('regType');
                if(item.status == 1){
                    this.Form.TaxMode = 1;
                    this.Form.HSNApplicable = true;
                }
                else{
                    this.Form.TaxMode = 0;
                    this.Form.HSNApplicable = false;
                }
                // this.$parent.fn_closeDialog();
            },

            fn_toUpperCase: function(val){
                this.Form.GSTNumber = val.toUpperCase();
            },

            fn_openRegistrationTypes: function(){
                this.fn_openDialogWeb('web', 'OTP', 'ref_dialogRegistrationTypes');
            },

            fn_checkValidations: function(){
                this.$validator.validateAll().then((result) => {
                    if (result) {

                        // if(this.e1 === 1){
                        //     this.e1++;
                        // }
                        // else{
                            
                        // }

                        if(this.Form.GSTRegistrationStatus==3){
                            this.Form.GSTNumber = null;
                            this.Form.GSTRegistrationDate = null;
                            this.Form.HSNApplicable = false;
                        }

                        if(this.Form.GSTRegistrationStatus==2){
                            this.Form.HSNApplicable = false;
                        }

                        if(!navigator.onLine){
                            this.saveBtnKey++;
                            this.showToast(this.$t('common.internetNotAvailable'));
                            return;
                        }

                        // let self = this;
                        this.showLoading(this.$t('signup.savingDetails'));
                        this.$root.fn_getAuthToken(token=>{
                            if(token == 'error'){
                                this.saveBtnKey++;
                                this.hideLoading();
                            }
                            else{
                                this.fn_registerBusiness(token)   
                            }
                            // token != 'error'  ?  self.fn_registerBusiness(token) : '';
                        })
                    }
                    else{
                        this.saveBtnKey++;
                        this.$vuetify.goTo('.error--text', this.scrollOptions);
                    }
                });
            },

            fn_openDialogWeb: function (platform, name, ref) {

                let scroll_y = window.scrollY;
                this.fn_fixBackgroundScroll();

                var dialogObj = {};
                dialogObj.tagId = this.guidWeb();
                dialogObj.formId = this.formId;
                dialogObj.name = name;
                dialogObj.ref = ref;
                dialogObj.data = null;
                dialogObj.platform = platform;

                dialogObj.scrollPosition = {};
                dialogObj.scrollPosition.x = 0;
                dialogObj.scrollPosition.y = scroll_y;

                dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

                this.$refs[ref].openDialogWeb();
            },

            fn_openStateDialog: function (platform, name, ref) {

                var tagId = this.guidWeb();

                var dialogObj = {};
                dialogObj.tagId = tagId;
                dialogObj.formId = this.formId;
                dialogObj.name = name;
                dialogObj.ref = ref;
                //dialogObj.data = null;
                dialogObj.platform = platform;



                var viewDialogObject = {};
                viewDialogObject.ToolbarTitle = this.$t('signup.selectStateTitle');
                viewDialogObject.isBottomMenu = false;
                viewDialogObject.closeBtnText = this.$t('signup.close');

                var paramObject = {};
                paramObject.defaultValue = {"id":null, "name":null};

                if(this.Form.StateID && this.Form.State){
                    paramObject.defaultValue = {"id":this.Form.StateID, "name":this.Form.State};
                }
                
                dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'state', tagId, paramObject, ref);
            },

            fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
                this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
            },

            fn_updateState: function (selectedValueId, selectedValueName, isRemoved) {
                if(!isRemoved){
                    this.Form.StateID = selectedValueId;
                    this.Form.State = selectedValueName;
                    this.errors.remove('state');
                }
                else{
                    this.Form.StateID = null;
                    this.Form.State = null;
                }
                this.$forceUpdate();
            },

            fn_closeDialog: function () {
                dialogjs.fn_checkAndCloseOpenDialogs(this);
            },

            fn_openDatepicker: function () {
                this.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePicker');
            },

            fn_getOpeningDate: function(){
                let openingDate = this.Form.OpeningDate ? new Date(this.Form.OpeningDate) : new Date("04/01/2022");
                return ("0" + openingDate.getDate()).slice(-2) + '/' + ("0" + (openingDate.getMonth() + 1)).slice(-2) + '/' + openingDate.getFullYear() //this.$moment(openingDate).format('DD/MM/YYYY');
            },

            fn_updateDate: function (value) {
                this.Form.OpeningDate = value;
                this.fn_closeDialog();
            },

            fn_showWebView: function () {
                var viewObject = {};
                viewObject.isBottomMenu = true;

                var tagId = this.formId;
                var self = this;
                this.showWebView(tagId, viewObject, 
                    {
                        onSuccess: function(response){
                          console.log(response);
                        }, 
                        onError: function(error){
                          console.log(error);
                        }, 
                        // onChange: null,
                        onMenuItemClick: function (tagId, menuId, menuAction) {
                            self.fn_menuItemClick(tagId, menuId, menuAction)
                        }
                    }
                );
            },

            fn_getLocalDateFormat: function(dateObj){
                let now = dateObj ? new Date(dateObj) : new Date();
                let year = now.getFullYear();
                let month = ("0" + (now.getMonth()+1)).slice(-2);
                let date = ("0" + now.getDate()).slice(-2);
                let time = now.toTimeString().substring(0, now.toTimeString().indexOf(' '));
                return year + '-' + month + '-' + date + 'T' + time + '.' + now.getMilliseconds();
            },

            fn_registerBusiness: function(token){
                if(!navigator.onLine){
                    this.saveBtnKey++;
                    this.showToast(this.$t('common.internetNotAvailable'));
                    return;
                }

                // this.Form.OpeningDate = new Date("04/01/2020");
                
                var self = this;
                // this.msgAlert = false;
                // this.showLoading('Please wait...');
                this.$forceUpdate();

                this.Form.GSTNumber ? this.Form.GSTNumber = this.Form.GSTNumber.toUpperCase() : '';
                this.Form.token = token;

                let openingDate = new Date(this.Form.OpeningDate);
                openingDate.setHours(0,0,0,0);
                this.Form.OpeningDate = this.fn_getLocalDateFormat(openingDate);
                // this.$route.query.usertype == 2 ? this.Form.IsAccountantOnly = true : '';

                this.Form.BusinessName = this.Form.BusinessName ? this.Form.BusinessName.trim() : null;

                // if(this.$route.query.usertype == 2){
                //     this.Form.IsAccountantOnly = true;
                //     this.Form.BusinessName = this.Form.UserName;
                //     this.Form.GSTRegistrationStatus = null;
                //     this.Form.TaxMode = null;
                //     this.Form.HSNApplicable = false;
                // }
                // if(this.isAccountant){
                //     this.Form.UserType = 2;
                // }

                console.log(JSON.stringify(this.Form));
                this.postServerData('RegisterBusiness', this.Form, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            let registerBusinessResponse = JSON.parse(response);
                            self.fn_signInUsingToken(registerBusinessResponse);

                            // posting metrics to server
                            let postObj = {
                                "eventName":"register_business",
                                "eventData":[
                                    {"eventKey":"BusinessID","eventValue":registerBusinessResponse.Business.BusinessID},
                                    {"eventKey":"BusinessName","eventValue":registerBusinessResponse.Business.BusinessName}
                                ]
                            }
                            self.$root.fn_postMetrics(postObj);
                        //   self.hideLoading();
                        //   let resonseData = JSON.parse(response);
                        //   self.$root.CurrentBusiness = resonseData;
                        //   self.fn_saveBusinessToMaster(resonseData)
                        }, 
                        onError: function(error){
                          console.log(error);
                          if(typeof JSON.parse(error) == 'object'){
                            let response = JSON.parse(error);
                            if(response.Message === "User already have an active business!"){
                                self.fn_reLoginIfAlreadyRegistered(token)
                            }
                            else{
                                self.hideLoading();
                                self.saveBtnKey++;
                                // self.msgAlert = true;
                                self.showToast(response.Message);
                            }
                          }
                        }, 
                    }
                );
            },

            fn_reLoginIfAlreadyRegistered: function(token){
                if(!navigator.onLine){
                    this.saveBtnKey++;
                    this.hideLoading();
                    this.showToast(this.$t('common.internetNotAvailable'));
                    return;
                }
                
                var self = this;
                let postObj = {};
                postObj.DeviceName = this.deviceInfo.DeviceName;
                postObj.AndroidVersion = this.deviceInfo.AndroidVersion;
                postObj.FCMID = null;
                postObj.DeviceType = 1;
                postObj.token = token;

                console.log(JSON.stringify(postObj));

                this.postServerData('Login', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);

                            let businessData = JSON.parse(response);
                            if(businessData.Business.length){
                                self.fn_confirmBusiness(businessData, token);
                            }
                        },
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                            self.saveBtnKey++;
                            if(typeof JSON.parse(error) == 'object'){
                                let response = JSON.parse(error);
                                self.showToast(response.Message);
                            }
                        }, 
                    }
                );
            },

            fn_confirmBusiness: function(businessData, token){
                
                var self = this;
                let postObj = {};
                let deviceId = AndroidRoutingTest.getDeviceId();
                postObj.DeviceID = deviceId ? deviceId : null;
                postObj.token = token;
                postObj.BusinessID = businessData.Business[0].BusinessID;
                postObj.IsRemote = businessData.Business[0].IsRemote;

                console.log(JSON.stringify(postObj));

                this.postServerData('ConfirmBusinessLogin', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            let tokenData = JSON.parse(response);
                            // self.fn_signInUsingToken(tokenData.Token, null, businessData);
                            // self.hideLoading();
                            let businessPostObj = {};
                            businessPostObj.Business = businessData.Business[0];
                            businessPostObj.Token = tokenData.Token;
                            self.fn_signInUsingToken(businessPostObj);
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.saveBtnKey++;
                            self.hideLoading();
                            if(typeof JSON.parse(error) == 'object'){
                                let response = JSON.parse(error);
                                self.showToast(response.Message);
                            }
                        }, 
                    }
                );
            },

            fn_signInUsingToken: function(registerBusinessResponse){
                if(!navigator.onLine){
                    this.showToast(this.$t('common.internetNotAvailable'));
                    this.saveBtnKey++;
                    this.hideLoading();
                    return;
                }

                let self = this;
                this.getData('SignInUsingToken', registerBusinessResponse.Token, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            // self.hideLoading();
                            // let resonseData = JSON.parse(registerBusinessResponse);
                            self.$root.CurrentBusiness = JSON.parse(JSON.stringify(registerBusinessResponse.Business));
                            self.fn_saveBusinessToMaster(registerBusinessResponse.Business);
                        }, 
                        onError: function(error){
                            self.saveBtnKey++;
                            self.hideLoading();
                            self.showToast(self.$t('common.somethingWentWrong'));
                            console.log(error);
                        }
                    }
                );
            },

            fn_saveBusinessToMaster: function(business, activated){
                let self = this;
                let postObj = JSON.parse(JSON.stringify(business));
                // postObj.CreatedOn = new Date(postObj.CreatedOn);
                // postObj.ModifiedOn = new Date(postObj.ModifiedOn);
                // postObj.OpeningDate = new Date(postObj.OpeningDate);
                // postObj.GSTRegistrationDate = postObj.GSTRegistrationDate ? new Date(postObj.GSTRegistrationDate) : null;
                postObj.isActive = 1;
                this.postData('SaveBusinessToMaster', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            if(activated){
                                self.confirmExit = true;
                                self.hideLoading();
                                self.showToast(self.$t('signup.businessActivatedPrefix') + business.BusinessName + self.$t('signup.businessActivatedSuffix'));
                                setTimeout(function(){
                                    self.$router.push({path:'/registration/business/restore_data', query:{exitapp:1}});
                                },300);
                            }
                            else{
                                self.fn_reopenDatabase(business);
                            }
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            fn_reopenDatabase: function(business){
                let self = this;
                this.getData('ReopenDataBase', business.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.fn_saveBusinessDetail(business);
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.showToast(self.$t('common.somethingWentWrong'));
                        }
                    }
                );
            },

            fn_saveBusinessDetail: function(business){
                let self = this;
                let postObj = JSON.parse(JSON.stringify(business));
                // postObj.CreatedOn = new Date(postObj.CreatedOn);
                // postObj.ModifiedOn = new Date(postObj.ModifiedOn);
                // postObj.OpeningDate = new Date(postObj.OpeningDate);
                // saving opening date in camel case
                // postObj.openingDate = new Date(business.OpeningDate);
                // postObj.GSTRegistrationDate = postObj.GSTRegistrationDate ? new Date(postObj.GSTRegistrationDate) : null;
                postObj.isActive = 1;
                postObj.webVersion = 10;
                this.postData('SaveBusinessDetail', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            
                            if(JSON.parse(response)){
                                self.confirmExit = true;
                                self.$root.fn_pushDefaultJson(function(){
                                    self.hideLoading();
                                    self.$root.fn_loadMainApp();
                                });
                                // if(self.$route.query.usertype==1){
                                //     self.$root.fn_pushDefaultJson(function(){
                                //         self.$root.fn_loadMainApp();
                                //     });
                                // }
                                // else{
                                //     self.$root.fn_loadMainApp();
                                // }
                                
                            }
                            else{
                                self.showToast(self.$t('common.somethingWentWrong'));
                            }
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.showToast(self.$t('common.somethingWentWrong'));
                        }, 
                    }
                );
            },

            fn_openDialogConfirmation: function (item) {
                if(item){
                    this.itemToActivate = item;
                    this.confirmationHeader = this.$t('signup.activateBusinessHeader');
                    this.confirmationMessage = this.$t('signup.activateBusinessPrefix') + this.itemToActivate.BusinessName + "?";
                    this.actionMethod = this.fn_activateBusiness;
                }
                else{
                    this.confirmationHeader = this.$t('signup.quitRegistrationHeader');
                    this.confirmationMessage = this.$t('signup.quitRegistrationMessage');
                    this.actionMethod = this.fn_confirmExit;
                }
                this.fn_openDialogWeb('web', 'OTP', 'ref_dialogConfirmation');
            },

            fn_confirmExit: function(){
                this.confirmExit = true;
                this.fn_closeDialog();
                this.fn_goBack();
            },

            fn_openDialogACtivateBusiness: function(){
                this.fn_openDialogWeb('web', 'OTP', 'ref_dialogActivateBusiness');  
                !this.businesses ? this.fn_getDeactivatedBusinesses() : '';
            },

            fn_getDeactivatedBusinesses: function(){

                let self = this;
                this.$root.fn_getAuthToken(function(token){
                    let filterObject = {};
                    filterObject.token = token;
                    self.getServerData('GetAllDeactiveBusiness', filterObject,
                        {
                            onSuccess: function(response){
                                console.log(response);
                                self.businesses = JSON.parse(response);
                            }, 
                            onError: function(error){
                                console.log(error);
                                self.hideLoading();
                                if(typeof JSON.parse(error) == 'object'){
                                    let response = JSON.parse(error);
                                    self.showToast(response.Message);
                                }
                            }, 
                        }
                    );    
                })
            },

            fn_activateBusiness: function(){

                this.fn_closeDialog();

                let self = this;

                this.$root.fn_getAuthToken(function(token){

                    let postObj = {};
                    postObj.BusinessID = self.itemToActivate.BusinessID;
                    /*global AndroidRoutingTest*/
                    postObj.DeviceID = AndroidRoutingTest.getDeviceId();
                    postObj.token = token;

                    console.log(JSON.stringify(postObj));

                    if(!navigator.onLine){
                       self.showToast(self.$t('common.internetNotAvailable'));
                       return;
                    }

                    self.showLoading(self.$t('signup.activatingPrefix') + self.itemToActivate.BusinessName);

                    
                    self.postServerData('ActivateBusiness', postObj,
                        {
                            onSuccess: function(response){
                                console.log(response);
                                self.$root.CurrentBusiness = JSON.parse(response);
                                self.fn_saveBusinessToMaster(self.$root.CurrentBusiness, true);
                                self.hideLoading();
                            }, 
                            onError: function(error){
                                console.log(error);
                                // self.msgAlert = true;
                                self.hideLoading();
                                if(typeof JSON.parse(error) == 'object'){
                                    let response = JSON.parse(error);
                                    self.showToast(response.Message);
                                }
                            }, 
                        }
                    );
                })
                
            },

            // fn_getStates: function () {
            //     let filterObject = {};
            //     filterObject.search = '';
			// 	filterObject.startIndex = 0;
			// 	filterObject.limit = 100;

            //     let self = this;
            //     this.getDialogItems("StateDialog", filterObject, 
            //         {
            //             onSuccess: function(response){
			// 				console.log(response);
            //                 self.states = JSON.parse(response);
            //             }, 
            //             onError: function(error){
            //                 console.log(error);
			// 				self.loading = false;
            //             }
            //         }
            //     );
            // },

            // fn_onGstNumberEdit: function(val){
            //     this.Form.GSTNumber = val.toUpperCase();
            //     if(this.states && this.states.length && val && val.length === 15){
            //         let stateCode = val.substring(0,2);
            //         let itemIndex = this.states.findIndex(state=>state.stateCode == stateCode);
            //         if(itemIndex != -1){
            //             this.Form.StateID = this.states[itemIndex].itemId;
            //             this.Form.State = this.states[itemIndex].itemName;
            //             return this.states[itemIndex].itemName;
            //         }
            //     }
            //     else{
            //         this.Form.StateID = null;
            //         this.Form.State = null;
            //     }
            // },

            fn_goBack: function(){
                // this.exitApp();
                this.$router.go(-1);
                // if(this.e1 <= 1){
                //     this.$router.go(-1);
                // }
                // else{
                //     this.e1--;
                // }   
            }
        },
        
        mounted: function(){

            // this.fn_getStates();

            if(this.$route.query && this.$route.query.user_name){
                this.Form.UserName = this.$route.query.user_name;
            }

            this.$validator.extend('verify_gstnumber', {
                // getMessage: field => 'GST Number is not valid.',
                getMessage: this.$t('signup.gstNumberInvalid'),
                validate: value => {
                    // var strongRegex = new RegExp("^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$");
                    var strongRegex = new RegExp("^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[a-zA-Z]{1}[0-9a-zA-Z]{1})+$");
                    return strongRegex.test(value);
                }
            });

            // this.$validator.extend('nospace', {
            //     validate: value => {
            //         var regpan = /^\S+$/;
            //         return regpan.test(value);
            //     }
            // });

            this.formId = this.guidWeb();
            this.dialogStorageId = 'dialog_'+this.formId;

            // Setting up default opening date as a first day of the month
            // let openingDate = new Date();
            // this.Form.OpeningDate = new Date((openingDate.getMonth() + 1) + '/1/' + openingDate.getFullYear());

            let currentDate = new Date();
            let currentFY = (currentDate.getMonth() + 1) < 4 ? currentDate.getFullYear() - 1 : currentDate.getFullYear();
            this.Form.OpeningDate = new Date('4/1/' + currentFY);

            window.js_globals.fn_onBackPress = this.fn_goBack;
            window.js_globals.fn_closeClick = this.fn_closeDialog;
            this.Form.DeviceID = AndroidRoutingTest.getDeviceId();

            this.fn_showWebView();
        },

        computed:{
            registrationType: function(){
                let type = null;
                for(let i in this.registrationTypes){
                    if(this.Form.GSTRegistrationStatus == this.registrationTypes[i].status){
                        type = this.registrationTypes[i].name;
                        break;
                    }
                }
                return type;
            },
            // saveBtnLabel: function(){
            //     if(this.e1 <= 1){
            //         return "Next";
            //     }
            //     else{
            //         return "Save";
            //     }
            // },
        },

        beforeRouteLeave (to, from, next) {
            var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
            if(dialogData && dialogData.length){
                dialogjs.fn_checkAndCloseOpenDialogs(this);
                next(false);
            }
            else if(!this.confirmExit){
                this.fn_openDialogConfirmation();
                next(false);
            }
            else{
                next();
            }
        }
    }
</script>

<style>
.native_checkbox{
   height:20px;
   width:20px;
}
.v-list-item.selected-list-radio{
    background: #42A5F5 !important;
}
.v-list-item.selected-list-radio .v-list-item__title{
    color: #ffffff !important;
}
.v-list-item.selected-list-radio .v-list-item__action .v-icon{
    color: #ffffff !important;
}
</style>